<template>
    <div v-if="bannerData" :class="['status-banner', bannerData.bgClass]">
      <div class="status-title">
        <img :src="require(`../assets/status-banner-icons/${bannerData.icon}`)" />
        <p>{{ bannerData.title }}</p>
      </div>
      <p v-if="!bannerData">Banner not active or data is missing</p>

      {{ bannerData.message }}
    </div>
</template>
  
<script>
  export default {
    props: {
      variantPayload: {
        type: Object,
        required: false,
        default: null
      }
    },
    computed: {
      bannerData() {
        return this.variantPayload || null;
      }
    }
  };
</script>

<style>
.status-banner {
    text-align: center;
    padding: 1rem;
    position: sticky;
}
.status-title {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        height: 1.125rem;
        width: auto;
        margin-right: 0.5rem;
    }

    p {
        font-size: 1.125rem;
        font-weight: 700;
        margin-bottom: 0;
    }
}
.red {
    background-color: #F29B9B;
}
.yellow {
    background-color: #F8E3A3;
}
.green {
    background-color: #BDE1BF;
}
</style>